import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from './api';
import Cookies from 'js-cookie';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_KEY;

// Αρχική κατάσταση για το auth slice
const initialState = {
  isAdmin: false,
  status: 'idle',
  user:{first_name: null, last_name:null},
  error: null,
  logout: false,
};

// Asynchronous thunk action for logging in
export const login = createAsyncThunk(
  'auth/login',
  async ({ username, password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/auth/login/`, { username, password });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message || 'Λάθος κωδικός ή όνομα χρήστη. Δοκιμάστε ξανά.');
    }
  }
);

// Asynchronous thunk action for logout 
export const logout = createAsyncThunk(
  'auth/logout',
  async (logoutData, { rejectWithValue }) => {
    try {
      const response = await api.post(`${API_URL}/auth/logout/`, logoutData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data.message || 'Logout failed.');
    }
  }
);

// Asynchronous thunk action for verifying the token
export const verifyToken = createAsyncThunk(
  'auth/verifyToken',
  async (token, { rejectWithValue }) => {
    try {
      const response = await axios.post('/auth/verify/', { token });
      return response.data;
    } catch (error) {
      const message = error.response ? error.response.data.message : 'Network error';
      return rejectWithValue(message);
    }
  }
);

// Consolidated refreshToken
export const refreshToken = createAsyncThunk(
  'auth/refreshToken',
  async (tokenRefresh, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/auth/token/refresh/`, { refresh: tokenRefresh });
      return response.data;
    } catch (error) {
      return rejectWithValue('Failed to refresh token.');
    }
  }
);

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setError(state, action) {
      state.error = action.payload;
    },
    setLogout(state, action) {
      state.logout = action.payload;

    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.status = 'loading';
        state.error = null;

      })
      .addCase(login.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.logout = false;
        state.user.first_name = action.payload.first_name
        state.user.last_name = action.payload.last_name
        Cookies.set('tokenAccess', action.payload.access, { expires: 1 });
        Cookies.set('tokenRefresh', action.payload.refresh, { expires: 1 });
      })
      .addCase(login.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      // Logout reducers
      .addCase(logout.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(logout.fulfilled, (state) => {
        state.status = 'succeeded';
        state.logout = true
        state.isAdmin = null;
        Cookies.remove('tokenAccess');
        Cookies.remove('tokenRefresh');
      })
      .addCase(logout.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      .addCase(verifyToken.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(verifyToken.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(verifyToken.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })

      .addCase(refreshToken.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.status = 'succeeded';
        Cookies.set('tokenAccess', action.payload.access, { expires: 1 });
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
        Cookies.remove('tokenAccess'); 
        Cookies.remove('tokenRefresh');
        state.isAdmin = null;
      });
  },
});

export const { setError, setLogout } = authSlice.actions;
export const selectAuth = (state) => state.auth;
export default authSlice.reducer;
